<ngx-loading [show]="loading"></ngx-loading>
<ngx-loading [show]="disableGrid" id="gridDisableDiv"></ngx-loading>
<div class="h-100 mb-2 overflow-auto">
  <div class="row mx-0 my-2">
    <div class="col-xl-5">
      <div class="row mx-0 my-2" *ngIf="clinic">
        <div class="col d-flex align-items-center teal-font bigger">
          <label class="switch">
            <input type="checkbox" [(ngModel)]="clinic.isUsingMerchantDevices" (change)="toggleMerchantDevices()" />
            <span class="slider round"></span>
          </label>
          <span class="pl-2">Enable Merchant Devices</span>
        </div>
      </div>
      <div class="row mx-0 my-2 ml-1">
        <div class="col px-0">
          <div class="section-header">Details</div>
          <div class="border p-2">
            Please speak to your sales representative for more information on how to integrate your merchant devices.
          </div>
        </div>
      </div>
      <div class="row mx-0 my-3 ml-1">
        <div class="col px-0">
          <div class="section-header">Merchant Account Settings</div>
          <div class="border p-2">
            <form class="d-flex flex-column h-100" [formGroup]="accountSettingsFormGroup">
              <div class="row">
                <div class="col d-flex align-items-center">
                  <mat-form-field class="w-100 px-2">
                    <mat-label>Chain</mat-label>
                    <input matInput formControlName="chain" />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col d-flex align-items-center">
                  <mat-form-field class="w-100 px-2">
                    <mat-label>Location</mat-label>
                    <input matInput formControlName="location" />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col d-flex align-items-center">
                  <mat-form-field class="w-100 px-2">
                    <mat-label>Terminal</mat-label>
                    <input matInput formControlName="terminal" />
                  </mat-form-field>
                </div>
              </div>
              <!-- Save or Cancel -->
              <div class="d-flex justify-content-end py-2">
                <button
                  class="btn medium em-btn em-btn-green mr-2"
                  type="button"
                  (click)="onSaveMerchantDeviceSettings()"
                  [disabled]="accountSettingsFormGroup.pristine || !accountSettingsFormGroup.valid"
                >
                  <i class="far fa-save"></i> Save
                </button>
                <button
                  class="btn medium em-btn em-btn-green"
                  type="button"
                  (click)="onCancelMerchantDeviceSettings()"
                  [disabled]="accountSettingsFormGroup.pristine"
                >
                  <i class="far fa-minus-circle"></i> Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div *ngIf="clinic?.isUsingMerchantDevices" class="row my-3">
        <div class="col">
          <kendo-grid
            class="ml-1"
            [data]="gridData"
            [style.height.%]="100"
            (add)="onAddClick($event)"
            (edit)="editHandler($event)"
            (remove)="removeHandler($event)"
          >
            <ng-template kendoGridToolbarTemplate>
              <div class="d-flex">
                <button kendoGridAddCommand class="p-2 btn em-btn">
                  <i class="fal fa-plus-circle"></i> Add Merchant Device
                </button>
              </div>
            </ng-template>
            <kendo-grid-column field="deviceFriendlyName" title="Name"> </kendo-grid-column>
            <kendo-grid-column field="pairingCode" title="Pairing Code"> </kendo-grid-column>
            <kendo-grid-column field="deviceId" title="Device Id"> </kendo-grid-column>
            <kendo-grid-column field="serialNumber" title="Serial Number"> </kendo-grid-column>
            <kendo-grid-command-column title="Actions" [width]="100">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                <button kendoGridEditCommand class="btn kendo-btn"><i class="fas fa-edit"></i></button>
                <button kendoGridRemoveCommand class="btn kendo-btn"><i class="fas fa-minus-circle"></i></button>
              </ng-template>
            </kendo-grid-command-column>
          </kendo-grid>
        </div>
      </div>
    </div>
    <div class="col-xl-5">
      <div class="row mx-0 my-2" *ngIf="clinic">
        <div class="col d-flex align-items-center teal-font bigger">
          <label class="switch">
            <input
              type="checkbox"
              [(ngModel)]="clinic.isUsingOnlinePayments"
              (change)="toggleOnlinePaymentAccountSettings()"
            />
            <span class="slider round"></span>
          </label>
          <span class="pl-2">Enable Online Payments</span>
        </div>
      </div>
      <div class="row mx-0 my-2 ml-1">
        <div class="col px-0">
          <div class="section-header">Details</div>
          <div class="border p-2">
            Please speak to your sales representative for more information on how to integrate online payments..
          </div>
        </div>
      </div>
      <div class="row mx-0 my-3 ml-1">
        <div class="col px-0">
          <div class="section-header">Online Payment Settings</div>
          <div class="border p-2">
            <form class="d-flex flex-column h-100" [formGroup]="onlinePaymentAccountSettingsFormGroup">
              <div class="row">
                <div class="col d-flex align-items-center">
                  <mat-form-field class="w-100 px-2">
                    <mat-label>Account Id</mat-label>
                    <input matInput formControlName="merchantId" />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col d-flex align-items-center">
                  <mat-form-field class="w-100 px-2">
                    <mat-label>User Id</mat-label>
                    <input matInput formControlName="merchantUserId" />
                  </mat-form-field>
                </div>
              </div>
              <div class="row">
                <div class="col d-flex align-items-center">
                  <mat-form-field class="w-100 px-2">
                    <mat-label>Pin Code</mat-label>
                    <input matInput formControlName="merchantPinCode" />
                  </mat-form-field>
                </div>
              </div>
              <!-- Save or Cancel -->
              <div class="d-flex justify-content-end py-2">
                <button
                  class="btn medium em-btn em-btn-green mr-2"
                  type="button"
                  (click)="onSaveOnlinePaymentAccountSettings()"
                  [disabled]="
                    onlinePaymentAccountSettingsFormGroup.pristine || !onlinePaymentAccountSettingsFormGroup.valid
                  "
                >
                  <i class="far fa-save"></i> Save
                </button>
                <button
                  class="btn medium em-btn em-btn-green"
                  type="button"
                  (click)="onCancelOnlinePaymentAccountSettings()"
                  [disabled]="onlinePaymentAccountSettingsFormGroup.pristine"
                >
                  <i class="far fa-minus-circle"></i> Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-actionpanel></app-actionpanel>
